import React from 'react';
import axios from 'axios';

import { useState, useEffect } from 'react';

import makeStyles from '@mui/styles/makeStyles';

import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';

import DepotGestionSelect from 'components/Shared/DepotGestionSelect';
import AdresseForm from 'components/Shared/AdresseForm';
import RepresentantGestionAutocomplete from 'components/Shared/RepresentantGestionAutocomplete';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';

import withLoader from 'components/Shared/withLoader';

import localStorageHelper from 'utils/localStorageHelper';

const DialogContentWithLoader = withLoader(DialogContent);

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%',
        marginBottom: theme.spacing(1)
    },
}));


/* Liste des réponses possibles */
const modeLabel = "Expédition vers le fournisseur";
const modes = [
    'Par le fournisseur',
    'Par nos soins (via l\'ATC / magasin, ...)',
];

const modeFournisseurLabel = "Expédition par le fournisseur";
const modesFournisseur = [
    'Dans un magasin',
    'Chez le client',
];

const modeFoussierLabel = "Expédition par nos soins";
const modesFoussier = [
    'Expédié depuis un magasin',
    'Expédié par l\'ATC',
    'Demande d\'enlèvement chez le client(facturé à Foussier)',
];

const adresseLabel = "Adresse d'enlèvement";


export default function EnvoiProduitFournisseurDialogContent({ onChange, action, reclamationId }) {

    const classes = useStyles();

    const [loading, setLoading] = useState(true);

    const [mode, setMode] = useState('');
    const [modeFournisseur, setModeFournisseur] = useState('');
    const [modeFoussier, setModeFoussier] = useState('');

    const [codeDepot, setCodeDepot] = useState(localStorageHelper.getCodeDepot({ magasin: true }));
    const [adresse, setAdresse] = useState(null);
    const [adresseStr, setAdresseStr] = useState('');

    const [representantNom, setRepresentantNom] = useState('');

    const [numeroBT, setNumeroBT] = useState('');
    const [commentaire, setCommentaire] = useState('');

    // /api/reclamations/94380/infos-logistique

    // Fetch des infos concernant  au chargement de la page
    useEffect(() => {
        const fetchData = async () => {

            await axios(`/api/reclamations/${reclamationId}/infos-logistique`) // TODO voir pour appeler une api plus simple.
                .then(function (response) {

                    let adr = {
                        nom: response.data.nomLivraison,
                        adresse1: response.data.livraisonAdresse1,
                        adresse2: response.data.livraisonAdresse2,
                        codePostal: response.data.livraisonCodePostal,
                        ville: response.data.livraisonVille,
                    };

                    setAdresse(adr);

                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    // always executed
                    setLoading(false);
                });
        };

        if (loading) {
            fetchData();
        }

    }, [reclamationId, loading]);

    useEffect(() => {
        setModeFournisseur('');
        setModeFoussier('');
    }, [mode]);

    useEffect(() => {
        setRepresentantNom('');
    }, [modeFournisseur]);

    useEffect(() => {
        setRepresentantNom('');
    }, [modeFoussier]);

    useEffect(() => {

        const getActionData = () => {

            if (mode === '') {
                return null;
            }

            if (mode === 0 && modeFournisseur === '') {
                return null;
            }

            if (mode === 0 && modeFournisseur === 0 && codeDepot === '') {
                return null;
            }

            if (mode === 0 && modeFournisseur === 1 && adresseStr === '') {
                return null;
            }

            if (mode === 1 && modeFoussier === '') {
                return null;
            }

            if (mode === 1 && modeFoussier === 0 && codeDepot === '') {
                return null;
            }

            if (mode === 1 && modeFoussier === 1 && representantNom === '') {
                return null;
            }

            if (mode === 1 && modeFoussier === 2 && adresseStr === '') {
                return null;
            }

            let warning = '';

            let actionData =
            {
                code: action.code,
                details: [
                    {
                        code: ReclamationActionDetailCodes.Resultat,
                        type: ReclamationActionDetailType.ChoixSimple,
                        libelle: modeLabel,
                        position: 0,
                        valeurString: modes[mode],
                        valeurInteger: mode
                    }],
                reponseAttendue: false // false pour ne pas bloquer les mémos.
            };

            if (mode === 0) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.Resultat,
                    type: ReclamationActionDetailType.ChoixSimple,
                    libelle: modeFournisseurLabel,
                    position: actionData.details.length,
                    valeurString: modesFournisseur[modeFournisseur],
                    valeurInteger: modeFournisseur
                });

                if (modeFournisseur === 0) {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.Depot,
                        type: ReclamationActionDetailType.CodeDepot,
                        libelle: modesFournisseur[modeFournisseur],
                        position: actionData.details.length,
                        valeurString: codeDepot
                    });
                }
                if (modeFournisseur === 1) {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.Adresse,
                        type: ReclamationActionDetailType.Texte,
                        libelle: adresseLabel,
                        position: actionData.details.length,
                        valeurString: adresseStr
                    });
                }
            }

            if (mode === 1) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.Resultat,
                    type: ReclamationActionDetailType.ChoixSimple,
                    libelle: modeFoussierLabel,
                    position: actionData.details.length,
                    valeurString: modesFoussier[modeFoussier],
                    valeurInteger: modeFoussier
                });

                if (modeFoussier === 0) {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.Depot,
                        type: ReclamationActionDetailType.CodeDepot,
                        libelle: modesFoussier[modeFoussier],
                        position: actionData.details.length,
                        valeurString: codeDepot
                    });
                }
                if (modeFoussier === 1) {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.Resultat,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "ATC",
                        position: actionData.details.length,
                        valeurString: representantNom,
                    });
                }
                if (modeFoussier === 2) {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.Adresse,
                        type: ReclamationActionDetailType.Texte,
                        libelle: adresseLabel,
                        position: actionData.details.length,
                        valeurString: adresseStr
                    });

                    warning = "Utiliser l'action \"Demande d'enlèvement\" pour procèder à cet enlèvement.";
                }
            }

            if (commentaire !== '') {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.Commentaire,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Commentaire",
                    position: actionData.details.length,
                    valeurString: commentaire
                });
            }

            if (numeroBT !== '') {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.NumeroBT,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Numéro de BT",
                    position: actionData.details.length,
                    valeurString: numeroBT
                });
            }

            return { actionData, warning };
        }

        const data = getActionData();

        if (data) {
            onChange(data.actionData, null, data.warning);
        }
        else {
            onChange(null, null, '');
        }

    }, [action.code, onChange, mode, modeFournisseur, modeFoussier, codeDepot, adresseStr, representantNom, commentaire, numeroBT]);


    return (
        <DialogContentWithLoader isLoading={loading}>

            <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">{modeLabel}</FormLabel>
                <RadioGroup
                    value={mode.toString()}
                    onChange={e => setMode(parseInt(e.target.value, 10))}
                >
                    {modes.map((m, index) => (
                        <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={m} />
                    ))}

                </RadioGroup>
            </FormControl>

            {mode === 0 && (

                <React.Fragment>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <FormLabel component="legend">{modeFournisseurLabel}</FormLabel>
                        <RadioGroup
                            value={modeFournisseur.toString()}
                            onChange={e => setModeFournisseur(parseInt(e.target.value, 10))}
                        >
                            {modesFournisseur.map((m, index) => (
                                <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={m} />
                            ))}

                        </RadioGroup>
                    </FormControl>

                    {modeFournisseur === 0 && (
                        <DepotGestionSelect className={classes.formControl} value={codeDepot} onChange={(e, code) => setCodeDepot(code)} valueIsCode magasinsSeulement isRequired autoFocus label="Sélectionner un magasin :" modeTri={1} />
                    )}

                    {modeFournisseur === 1 && (
                        <AdresseForm
                            label={adresseLabel}
                            adresse={adresse}
                            onChange={(addr, addrStr) => { setAdresse(addr); setAdresseStr(addrStr); }}
                        />
                    )}

                </React.Fragment>

            )}


            {mode === 1 && (

                <React.Fragment>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <FormLabel component="legend">{modeFoussierLabel}</FormLabel>
                        <RadioGroup
                            value={modeFoussier.toString()}
                            onChange={e => setModeFoussier(parseInt(e.target.value, 10))}
                        >
                            {modesFoussier.map((m, index) => (
                                <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={m} />
                            ))}

                        </RadioGroup>
                    </FormControl>


                    {modeFoussier === 0 && (
                        <DepotGestionSelect
                            className={classes.formControl}
                            value={codeDepot}
                            onChange={(e, code) => setCodeDepot(code)}
                            valueIsCode
                            magasinsSeulement
                            isRequired
                            autoFocus
                            label="Sélectionner un magasin :" modeTri={1}
                        />
                    )}

                    {modeFoussier === 1 && (

                        <RepresentantGestionAutocomplete
                            onChange={representant => setRepresentantNom(representant.nom)}
                            required
                        />
                    )}

                    {modeFoussier === 2 && (
                        <AdresseForm
                            label={adresseLabel}
                            adresse={adresse}
                            onChange={(addr, addrStr) => { setAdresse(addr); setAdresseStr(addrStr); }}
                        />
                    )}

                </React.Fragment>
            )}

            {mode !== '' &&
                <>
                    <TextField
                        className={classes.textField}
                        fullWidth
                        id="numeroBt"
                        name="numeroBt"
                        label="Numéro de BT"
                        placeholder="Numéro de BT"
                        margin="normal"
                        value={numeroBT}
                        onChange={e => { setNumeroBT(e.target.value); }}
                        sx={{ mb: 0 }}
                    />

                    <TextField
                        className={classes.textField}
                        fullWidth
                        id="commentaire"
                        name="commentaire"
                        label="Commentaire"
                        placeholder="Commentaire"
                        multiline
                        margin="normal"
                        value={commentaire}
                        onChange={e => { setCommentaire(e.target.value); }}
                    />
                </>
            }

        </DialogContentWithLoader>
    );

}